module.exports = __webpack_public_path__ + "img/slide-4.e60893d7.png";